import { z } from "zod";

import { agentReceiptSchema } from "./agent-receipt.contract.ts";

export const guardedAgentReceiptSchema = agentReceiptSchema.safeExtend({
    automationChanged: z.boolean().optional(),
});

export type GuardedAgentReceipt = z.infer<typeof guardedAgentReceiptSchema>;
